import useLazyQuery from 'api/hooks/useLazyQuery';
import permissions from 'api/Apollo/permissions';
import { buildVariables, GET_EVENT_SCHEMAS } from './event-schemas-query-builder';

export default function useLazyQueryEventSchemas({ ...options } = {}) {
  const [executeQuery, { data, ...rest }] = useLazyQuery(GET_EVENT_SCHEMAS, {
    context: { permission: permissions.readSchemas },
    // Not using the cache so we can dynamically refresh whenever a new event schema is created.
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-and-network',
    ...options,
  });

  const getEventSchemas = ({ schemaLibraryVersionId, page, perPage }) => {
    const variables = buildVariables({ schemaLibraryVersionId, page, perPage });

    return executeQuery({ variables });
  };

  return [getEventSchemas, { ...transformData(data), ...rest }];
}

function transformData(data) {
  if (!data) {
    return {
      data: [],
      pagination: { count: null },
    };
  }

  const { schemaLibraryEventSchemas, schemaLibraryEventSchemasAggregate } = data;

  return {
    data: schemaLibraryEventSchemas,
    pagination: { count: schemaLibraryEventSchemasAggregate.aggregate.count },
  };
}
